import { render, staticRenderFns } from "./DoriSummary.vue?vue&type=template&id=810038aa&scoped=true&"
import script from "./DoriSummary.vue?vue&type=script&lang=ts&"
export * from "./DoriSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810038aa",
  null
  
)

export default component.exports